import { TextField, FormControl, Grid, Button, MenuItem } from '@mui/material'
import { LinearLoading, CustomAutocomplete } from 'common'

export const FilterMovements = ({ useFetchInit }) => {

    const { Forms, FetchData, Actions, Helpers } = useFetchInit

    const { FilterMovements: FilterMovementsForm } = Forms
    const { formState } = FilterMovementsForm

    const { fetchAllBanks, fetchBankMovements } = FetchData
    const { banks } = fetchAllBanks
    const { loadingFetchBankMovements, summaryBankMovements } = fetchBankMovements

    const {
        onSubmitFilterMovements,
        handleClickPrintMovementsReport,
        handleChangeMovementStartDate,
        handleChangeMovementEndDate,
        handleChangeMovementIdbanco,
        handleChangeMovementTipoFilter,
    } = Actions

    const { formatMoney } = Helpers

    const kpis = [
        { title: 'Total Ingresos', q: summaryBankMovements?.ingresos?.quetzales, usd: summaryBankMovements?.ingresos?.dolares },
        { title: 'Total Egresos', q: summaryBankMovements?.egresos?.quetzales, usd: summaryBankMovements?.egresos?.dolares },
        { title: 'Balance (I - E)', q: summaryBankMovements?.balance?.quetzales, usd: summaryBankMovements?.balance?.dolares },
        { title: 'Balance Historico', q: summaryBankMovements?.fullBalance?.historico_quetzales, usd: summaryBankMovements?.fullBalance?.historico_dolares },
        { title: 'Balance Total', q: summaryBankMovements?.fullBalance?.quetzales, usd: summaryBankMovements?.fullBalance?.dolares },
    ]

    return (
        <>
            {loadingFetchBankMovements && (<LinearLoading />)}

            <form onSubmit={onSubmitFilterMovements}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="startDate">* Fecha de inicio</label>
                            <TextField
                                id='startDate'
                                name='startDate'
                                value={formState.startDate}
                                onChange={handleChangeMovementStartDate}
                                size='small'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="endDate">* Fecha fin</label>
                            <TextField
                                id='endDate'
                                name='endDate'
                                value={formState.endDate}
                                onChange={handleChangeMovementEndDate}
                                size='small'
                                type='date'
                                variant='outlined'
                                hiddenLabel
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>

                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="idbanco">Banco</label>
                            <CustomAutocomplete
                                customId="idbanco"
                                customName="idbanco"
                                customValue={formState.idbanco}
                                customOnChange={(target, value) =>
                                    handleChangeMovementIdbanco({ target: { name: 'idbanco', value: value.value } })
                                }
                                customPlaceholder='Seleccionar banco'
                                customOptions={[
                                    { value: 'ALL', name: 'Todos los bancos' },
                                    ...banks.map(({ idbanco, nombre }) => ({
                                        value: String(idbanco),
                                        name: nombre
                                    }))
                                ]}
                                customDisableClearable={true}
                                customDisabled={false}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="movimiento_tipo">Tipo</label>
                            <TextField
                                id="movimiento_tipo"
                                name="movimiento_tipo"
                                value={formState.movimiento_tipo}
                                onChange={handleChangeMovementTipoFilter}
                                select
                                size="small"
                                variant='outlined'
                                hiddenLabel
                            >
                                <MenuItem value='ALL'>MOVIMIENTOS (INGRESO + EGRESO)</MenuItem>
                                <MenuItem value='INGRESO'>INGRESO</MenuItem>
                                <MenuItem value='EGRESO'>EGRESO</MenuItem>
                            </TextField>
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-3"></div>
                <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    {kpis.map(({ title, q, usd }) => (
                        <Grid item xs={12} md={2} key={title}>
                            <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: 10 }}>
                                <strong>{title}</strong>
                                <div>Q. {formatMoney(q ?? 0)}</div>
                                <div>$ {formatMoney(usd ?? 0)}</div>
                            </div>
                        </Grid>
                    ))}
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item>
                        <Button
                            style={{ background: '#4b4b4c' }}
                            variant="contained"
                            type="button"
                            onClick={handleClickPrintMovementsReport}
                        >
                            <i className="fas fa-print"></i> &nbsp; Imprimir
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
